export var FidoEnrollmentEligibility;
(function (FidoEnrollmentEligibility) {
    FidoEnrollmentEligibility["LINK_PASSKEY_EXTERNAL_UI"] = "LINK_PASSKEY_EXTERNAL_UI";
    FidoEnrollmentEligibility["CREATE_PASSKEY_EXTERNAL_UI"] = "CREATE_PASSKEY_EXTERNAL_UI";
    FidoEnrollmentEligibility["LINK_PASSKEY_SELF_UI"] = "LINK_PASSKEY_SELF_UI";
    FidoEnrollmentEligibility["CREATE_PASSKEY_SELF_UI"] = "CREATE_PASSKEY_SELF_UI";
    /** Default value if not defined */
    FidoEnrollmentEligibility["NONE"] = "NONE";
})(FidoEnrollmentEligibility || (FidoEnrollmentEligibility = {}));
